'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  height: 100%;
  display: flex;
  align-items: stretch;
  width: 100%;
  justify-content: stretch;
  position: relative;
  overflow: hidden;
`;

export const map = css`
  height: 100%;
  width: 100%;
  z-index: 0;
`;

export const show = css``;

export const placeDetails = css`
  position: absolute;
  left: 1rem;
  right: 1rem;
  max-width: min(calc(100% - 2rem), 750px);
  opacity: 0;
  bottom: -100%;
  transition: all 0.25s ease-in;
  z-index: 30;
  &.${show} {
    opacity: 1;
    bottom: 1rem;
    top: 1rem;
    @media screen and (width > ${theme.sizes.screens.md}) {
      top: unset;
      height: 250px;
    }
  }
`;

export const findMe = css`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 10;
  border: none;
  box-shadow: ${theme.elevation.peoople};
  width: 40px;
  height: 40px;
`;

export const loader = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  position: absolute;
  inset: 0;
`;

export const selected = css``;

export const marker = css`
  box-shadow: ${theme.elevation.small};
  &.${selected} {
    border: 2px solid ${theme.colors.peoople['azul-claro-medio']};
  }
`;
